import s from './clue.module.scss';

/**
 * Pas d'indice.
 *
 * Deux situations tres differentes arrivent ici, et c'est normal : un mini-jeu
 * ou tout se joue dans l'entree, et un indice qui s'est DEGRADE jusqu'a
 * disparaitre (la couleur a memoriser). Le serveur envoie `none` dans les deux
 * cas et ne dit pas lequel.
 *
 * On n'essaie donc pas de deviner : l'ecran affiche un vide assume. La
 * consigne de la question, elle, est toujours au-dessus et suffit a lever
 * l'ambiguite — « Reproduis cette couleur de memoire » se passe de commentaire.
 */
export function NoClue() {
  return (
    <div className={s.emptyStage} aria-label="Aucun indice affiche">
      <span className={s.emptyMark}>?</span>
      <p className={s.emptyHint}>De memoire.</p>
    </div>
  );
}
